<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="官网地址" prop="websiteVal">
        <a-input v-model="form.websiteVal" placeholder="请输入" />
      </a-form-model-item>
     <a-form-model-item label="官网电话" prop="extendS1">
         <a-input v-model="form.extendS1" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="企业介绍" prop="description">
        <a-textarea placeholder="请输入" v-model="form.description" :maxLength="200" />
      </a-form-model-item>
      <a-form-model-item label="广告语" prop="extendS6">
        <a-textarea placeholder="请输入" v-model="form.extendS6" :maxLength="16" />
      </a-form-model-item>
      <a-form-model-item label="公司图标" prop="logoUrl">
        <file-upload
          type="image"
          @input="getImg($event, 'logoUrl')"
          :file="form.logoUrl"
          :count="1"
          :isUpload="false"
          pathSrc="krpano/sc"
          :isSize="true"
          autoCropHeight="300"
          autoCropWidth=""
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="启动页1" prop="coverImageUrl">
        <file-upload
          type="image"
          @input="getImg($event, 'coverImageUrl')"
          :file="form.coverImageUrl"
          :count="1"
          :isUpload="false"
          :isSize="true"
          pathSrc="krpano/sc"
          autoCropHeight="1334"
          autoCropWidth=""
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="补地图" prop="supplementMapUrl">
        <file-upload
          type="image"
          @input="getImg($event, 'supplementMapUrl')"
          :file="form.supplementMapUrl"
          :count="1"
          :isUpload="false"
          :isSize="true"
          pathSrc="krpano/sc"
          autoCropHeight="300"
          autoCropWidth="300"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="分享图" prop="shareLogoUrl">
        <file-upload
          type="image"
          @input="getImg($event, 'shareLogoUrl')"
          :file="form.shareLogoUrl"
          :count="1"
          :isUpload="false"
          autoCropHeight="300"
          pathSrc="krpano/sc"
          :isSize="true"
          autoCropWidth="300"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="背景音乐" prop="backgroundMusicUrl">
        <a-upload
          accept=".mp3"
          :disabled="isUploading"
          :file-list="fileList"
          :maxCount="1"
          :customRequest="customRequest"
        >
          <a-button :loading="isUploading"> <a-icon type="upload" /> 上传文件 </a-button>
        </a-upload>
        <a-input v-model="form.backgroundMusicUrl" v-show="show"></a-input>
      </a-form-model-item>
      <!-- <a-form-model-item label="设备编号" prop="devCode">
        <a-input v-model="form.devCode" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { ossSignature } from '@/api/system/user'
import { tantEdit, tenantVrDetail } from '@/api/VR/tenantPlan/index'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'
export default {
  name: 'CreateForm',
  components: {},
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      show: false,
      data: [],
      fileList: [],
      formTitle: '',
      isUploading: false,
      // 表单参数
      form: {
        tenantId: undefined,
        backgroundMusicLoop: 1,
        backgroundMusicUrl: undefined,
        coverImageUrl: undefined,
        logoUrl: undefined,
        shareLogoUrl: undefined,
        supplementMapUrl: undefined,
        description: undefined,
        websiteVal: undefined,

      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        description: [{ required: true, message: '请输入企业介绍', trigger: 'blur' }],
        extendS1: [{ required: true, message: '请输入官网电话', trigger: 'blur' }],
        extendS6: [{ required: true, message: '请输入企业广告语', trigger: 'blur' }],
        websiteVal: [{ required: true, message: '请输入官网地址', trigger: 'blur' }],
        coverImageUrl: [{ required: true, message: '请上传启动页', trigger: 'blur' }],
        logoUrl: [{ required: true, message: '请上传公司图标', trigger: 'blur' }],
        supplementMapUrl: [{ required: true, message: '请上传补地图', trigger: 'blur' }],
        shareLogoUrl: [{ required: true, message: '请上传分享图', trigger: 'blur' }],
        backgroundMusicUrl: [{ required: true, message: '请上传背景音乐', trigger: 'blur' }],
        // backgroundMusicUrl: [{ required: true, message: '请上传背景音乐', trigger: 'blur' }],
        // backgroundMusicUrl: [{ required: true, message: '请上传背景音乐', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    // console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/file_${ymd}_${r}.${ext}`
      return cosKey
    },
    // 表单重置
    reset() {
      this.form = {
        tenantId: undefined,
        backgroundMusicLoop: 1,
        backgroundMusicUrl: undefined,
        coverImageUrl: undefined,
        logoUrl: undefined,
        shareLogoUrl: undefined,
        supplementMapUrl: undefined,
        description: undefined,
        websiteVal: undefined,
        extendS6: undefined,
        extendS1: undefined,
      }
    },
    customRequest(options) {
      const that = this
      this.isUploading = true
      const { file, onProgress, onSuccess, onError } = options
      this.fileList = [file] // 仅保留最新的一个文件
      console.log(file, onProgress, onSuccess, onError, 'file, onProgress, onSuccess, onError')
      console.log(file.name, '对对对对对对')
      var lastIndex = file.name.lastIndexOf('.')
      console.log('选择的图片路径fileName', lastIndex)
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      console.log(extName, 'extNameextNameextName')
      const cosKey = this.generateCosKey('krpano/sc', extName)
      const fileNames = cosKey.split('/').pop()
      ossSignature().then((res) => {
        res = res.data
        const cos = new COS({
          SecretId: res.tmpSecretId,
          SecretKey: res.tmpSecretKey,
          SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
          StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
          ExpiredTime: res.expiredTime, // 临时密钥过期时间
        })
        cos.putObject(
          {
            Bucket: this.$Bucket, // 对象存储桶名称
            Region: 'ap-beijing', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            SliceSize:
              1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) {},
          },
          function (err, data) {
            if (err) {
              console.log('上传失败', err)
            } else {
              console.log('上传成功')
              // that.form.cosKey = cosKey
              console.log(cosKey, 'cosKeycosKey')
              that.form.backgroundMusicUrl = cosKey
              that.isUploading = false
              // that.handleOk(cosKey)
            }
          }
        )
      })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加设备'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.form.tenantId = row.id
      //   const postId = row ? row.id : ids
      tenantVrDetail({ tenantId: row.id }).then((res) => {
        res = res.data
        console.log(res, '的点点滴滴')
      

        this.formTitle = '设置VR方案'
        if (res) {
          this.form = res
          this.form.tenantId = row.id
          // this.fileList = [this.$url + res.backgroundMusicUrl]
          const fullUrl = this.$url + res.backgroundMusicUrl
          // 2. 提取文件名（从存储路径 res.backgroundMusicUrl 中截取，如 "krpano/sc/file_20240828_123456_123456.mp3" → 截取最后一段）
          const fileName = res.backgroundMusicUrl.split('/').pop()
          this.fileList = [
            {
              uid: Date.now() + '', // 生成唯一标识（避免重复，用时间戳转字符串）
              name: fileName, // 文件名
              status: 'done', // 状态为“已完成”
              url: fullUrl, // 完整预览 URL
            },
          ]
        } else {
          this.fileList = []
        }
        this.open = true
      })

      //   getObj(postId).then((response) => {
      //     this.form = response.data
      //   })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          tantEdit(this.form)
            .then((response) => {
              this.$message.success('新增成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
          //   if (this.form.id !== undefined) {
          //     tantEdit(this.form)
          //       .then((response) => {
          //         this.$message.success('修改成功', 3)
          //         this.open = false
          //         this.$emit('ok')
          //       })
          //       .finally(() => {
          //         this.submitLoading = false
          //         this.showLoading = false
          //       })
          //   } else {
          //   }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
